import { globalConfig } from "@/global/config/global_config";
import { formatSeconds } from "@/global/utils/scheduler";
import { Box, useTheme } from "@mui/material";
import React, { useState } from "react";
const { checkoutSchedulerInterval } = globalConfig.purchaseCredit;

export const CountDownClockObserver = {
  shouldReset: false,
};

const initialTime = checkoutSchedulerInterval / 1000;

export function CountDownClock() {
  const theme = useTheme();
  const [time, setTime] = useState(initialTime);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTime((time) => {
        if (CountDownClockObserver.shouldReset) {
          CountDownClockObserver.shouldReset = false;
          return initialTime;
        }
        if (time == 0) {
          clearInterval(interval);
          return 0;
        }
        return time - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      width={"90px"}
      border={`1px solid ${theme.palette.divider}`}
      borderRadius={0.8}
      p={0.5}
      fontFamily={"Poppins"}
      fontSize={"1rem"}
      display={"flex"}
      justifyContent={"center"}
      color={theme.palette.grey[800]}
      alignItems={"center"}
    >
      {formatSeconds(time)}
    </Box>
  );
}
